import type { Dispatch, ReactNode, SetStateAction } from 'react'

import { createContext, useContext, useState } from 'react'

type State = {
  id: string
  mimeType: string
  position: 'split' | 'bottom'
  documentId: string
} | null

interface Context {
  document: State
  setDocument: Dispatch<SetStateAction<State>>
}

export const BehavioralContext = createContext<Context>({
  document: null,
  setDocument: () => ({})
})

export function BehavioralContextProvider ({ children }: { children: ReactNode }): JSX.Element {
  const [ document, setDocument ] = useState<State>(null)

  return (
    <BehavioralContext.Provider value={{ document, setDocument }}>
      {children}
    </BehavioralContext.Provider>
  )
}

export function useBehavioralContext (): Context {
  return useContext(BehavioralContext)
}
